const adminRoot = '/admin'
const adminPaths = {
  adminSoftwareReleases: adminRoot,
  adminUsers: `${adminRoot}/users`,
  adminUser: `${adminRoot}/users/:id`,
  adminOperations: `${adminRoot}/operations`,
  adminSettings: `${adminRoot}/settings`,
  adminStats: `${adminRoot}/stats`
} as const

const supportRoot = '/support'
const supportPaths = {
  supportOperations: supportRoot,
  supportVerifyEmail: `${supportRoot}/verify-email`,
  supportCreateDealerOrg: `${supportRoot}/create-dealer`
} as const

const mapRoute = '/:orgCode/map'

const operationRoot = '/:orgCode/operation'
const operationPaths = {
  home: '/:orgCode/home',
  devices: `${operationRoot}/devices`,
  members: `${operationRoot}/members`,
  dataSharing: `${operationRoot}/data-sharing`,
  softwareDownloads: `${operationRoot}/software-downloads`,
  feedback: `${operationRoot}/feedback`,
  billing: `${operationRoot}/billing`,
  manageOperation: operationRoot,
  applicationDataUpload: `${operationRoot}/upload-data`,
  fieldUpdate: `${operationRoot}/update-fields`,
  fields: `${operationRoot}/fields`,
  boundaries: `${operationRoot}/boundaries`,
  prescriptions: `${operationRoot}/prescriptions`,
  archiveList: `${operationRoot}/archive`,
  subscribeWithCode: '/:orgCode/subscribe-with-code'
} as const

const reportingRoot = '/:orgCode/reporting'

const dealerRoot = '/:orgCode/dealer'
const dealerPaths = {
  dealerOperations: dealerRoot,
  dealerMap: `${mapRoute}/dealer`,
  dealerCreateCustomerOp: `${dealerRoot}/create-customer-operation`,
  dealerHandoff: `${dealerRoot}/handoff/:farmerOrgCode`
} as const

const publicRoot = '/public'
export const publicPaths = {
  publicLanding: publicRoot,
  loginRequired: `${publicRoot}/login-required`,
  logoutMessage: `${publicRoot}/logout-message`,
  publicEula: `${publicRoot}/EULA`,
  refundPolicy: `${publicRoot}/refund-policy`,
  verifyEmail: `${publicRoot}/verify-email`,
  softwareUpdates: `${publicRoot}/software-updates`
} as const

export const path = {
  root: '/',
  notifications: '/:orgCode/notifications',
  postLivestreamRedirect: '/:orgCode/post-livestream-redirect',
  account: '/account',
  pair: '/pair',
  connectionDetails: '/connections/:partnerId',
  postSale: '/post-sale',
  acceptInvite: '/accept-invite',
  inactiveOperation: '/:orgCode/inactive-operation',
  gettingStarted: '/getting-started',
  createOperation: '/create-operation',
  eula: '/EULA',
  operationList: '/account/operations',
  updateEmailLogin: '/update-login',
  dealerShare: '/share/:dealerOrgCode',
  acceptHandoff: '/accept-handoff',
  acceptStreamCopy: '/accept-stream-copy',
  acceptCreateDealerInvite: '/create-dealer',
  map: mapRoute,
  reporting: reportingRoot,
  ...publicPaths,
  ...operationPaths,
  ...dealerPaths,
  ...adminPaths,
  ...supportPaths
} as const

export const SELECT_UNREGISTERED_FIELDS_PARAM = 'selectUnregistered'
